import {StrategyDto} from './strategy-dto.class';

export class EngineStrategyAddedDto {
  strategy: StrategyDto;
}
